<script setup lang="ts">
    import type { IRGB } from '@/typescript/interfaces/colors';

    const rgb = defineModel<IRGB>({ default: { r: 0, g: 0, b: 0 } });

    function updateRgb(newRgb: IRGB) {
        rgb.value = newRgb;
    }
</script>

<template>
    <div class="flex w-full flex-row justify-around gap-2">
        <input
            id="rgb-r"
            :aria-label="$t('colorpicker_aria_rgb_red')"
            :value="rgb.r"
            class="border-border h-8 w-1/3 rounded-md border text-center"
            min="0"
            max="255"
            @change="
                updateRgb({
                    r: Number(($event.target as HTMLInputElement).value),
                    g: rgb.g,
                    b: rgb.b,
                })
            "
        />
        <input
            id="rgb-g"
            :aria-label="$t('colorpicker_aria_rgb_green')"
            :value="rgb.g"
            class="border-border h-8 w-1/3 rounded-md border text-center"
            min="0"
            max="255"
            @change="
                updateRgb({
                    g: Number(($event.target as HTMLInputElement).value),
                    r: rgb.r,
                    b: rgb.b,
                })
            "
        />
        <input
            id="rgb-b"
            :aria-label="$t('colorpicker_aria_rgb_blue')"
            :value="rgb.b"
            class="border-border h-8 w-1/3 rounded-md border text-center"
            min="0"
            max="255"
            @change="
                updateRgb({
                    b: Number(($event.target as HTMLInputElement).value),
                    r: rgb.r,
                    g: rgb.g,
                })
            "
        />
    </div>
</template>
